// extracted by mini-css-extract-plugin
export var divider = "_jx-7";
export var itemsToggle = "_jx-8";
export var mergeModal = "_jx-1";
export var optionCard = "_jx-4";
export var radioGroup = "_jx-6";
export var radioOption = "_jx-0";
export var selected = "_jx-5";
export var shipmentOptions = "_jx-2";
export var tableOptions = "_jx-3";